import { render, staticRenderFns } from "./PDFTemplate.vue?vue&type=template&id=724f138e&scoped=true&"
import script from "./PDFTemplate.vue?vue&type=script&lang=ts&"
export * from "./PDFTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./PDFTemplate.vue?vue&type=style&index=0&id=724f138e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f138e",
  null
  
)

export default component.exports